import { isAxiosError } from 'axios'

// Maps a mutation failure to a SAFE, operationally-useful message. It classifies by
// HTTP status only and returns fixed copy — it never echoes the raw backend payload
// (which could carry internal identity identifiers) and never logs it.

export enum UserMutationKind {
	PROVISION = 'provision',
	ROLE = 'role',
	JOB_FUNCTION = 'job-function',
	STATUS = 'status',
}

export function describeUserMutationError(error: unknown, kind: UserMutationKind): string {
	const status = isAxiosError(error) ? error.response?.status : undefined

	if (status === 409) {
		if (kind === UserMutationKind.PROVISION) {
			return 'This email or identity conflicts with an existing account. Contact an operator to investigate.'
		}
		// A job function grants nothing, so it has no last-active-SUPER_ADMIN guard to
		// trip — only role/status can produce that 409.
		if (kind === UserMutationKind.JOB_FUNCTION)
			return 'That change conflicted with the current state. Refresh and try again.'
		return 'This change was blocked: the system must keep at least one active Super Admin.'
	}
	if (status === 400) return 'The request was invalid. Please review the fields and try again.'
	if (status === 403) return 'You do not have permission to perform this action.'
	if (status === 404) return 'That user could not be found. Refresh and try again.'
	return 'Something went wrong. Please try again.'
}
